// @flow
import React from 'react'
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import {styles} from './Styles/Banner.Style'

type Props = {
  classes: { [string]: string }
}

class Banner extends React.Component {
  props: Props

    render () {
      const {classes} = this.props

      return (
        <div className={classes.container}>
          <div className='container wrap'>
            <div className={classNames(classes.padding, 'row middle-xs')}>
              <div className='col-xs-12 center-xs'>
                <p className={classes.paragraph}>
                  The previous version of Partsee remains
                  accessible <a className={classes.link} href='http://v1.partsee.com'>here</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    }
}

export default injectSheet(styles)(Banner)



// WEBPACK FOOTER //
// ./src/layouts/Banner.jsx